export const AI_CHATBOT_ALLOWED_ROLE_IDS: string[] = [
	'dd4816d9-ac75-482b-b429-5084609022bc',
	'a28c6313-a8ab-42a8-8414-5c3818deba76',
	'912f6375-4f2b-47d7-8600-5b9f37a71e47',
	'ead35283-29a0-4e44-ad99-9714cba0125b',
	'30e92e1e-6d84-4610-b61f-03165edeff36',
	'108e8d9d-5ab9-4fe0-9ad7-988685470366',
	'5d05ab6b-7332-45e6-84cc-cd055c685e07',
	'e08591de-2e6b-4948-a09a-cb2c62804b58',
	'41a73b37-3885-4355-91bd-560fa4afd110',
	'e1f8db2f-089c-4c7e-a940-06246ebaa88f',
	'd0c394d4-936d-4bb3-a98f-5cce81152d77',
	'3207b204-6b96-4ab6-abfb-94fe51e4b497',
	'7a517abe-f730-4fc6-bfa7-e5f8bfe3bee9',
	'28d3280b-902a-4944-ab29-8298d4aa17d8',
	'3987b7f3-b9b1-4b9c-b11f-269afe493f5f',
	'b3f4b373-4116-47e8-8b5c-b4aaefaae17c',
	'e039277d-fd55-4925-9961-22eeaf7a738c',
	'5dc6fcd6-5ade-4bab-9623-ef649b086712',
	'0b55707c-4d66-49d9-a3d9-e9b2ac08be97',
	'83787924-b5e2-4200-b607-fa409394f713',
	'6abdf282-cd8e-4821-a678-1ecc0440fc34',
	'e9daddf2-a95e-4bd8-af22-ecc57c9d6045',
	'358eb015-f8ff-4f4a-ac2f-1957ae0326c1',
	'b23304d1-2965-4800-b1b2-1cda13421b47',
	'a42afa0a-d018-4b35-a2dc-c677d8d2bfe5',
	'e835c2e0-acc1-4883-9108-0cc2b68f8025',
	'd3f3145d-ac29-45cc-bd16-61a0ee29481e',
	'80ed1a35-c468-48d6-b8bf-5f8c4d8d192f',
	'19a99a9b-5eb0-4676-ab2c-7c2edc03c47a',
	'a77c1ceb-251b-4100-b3aa-488d2e26c6aa',
	'380431c9-fea9-48bb-ae97-2607d0388cea',
	'b8f64c13-7351-4054-a55f-928fc8edd4e4',
	'487a6422-844f-453e-b167-bca6f0b7e594',
	'947aecba-3d43-4ca4-a783-a03744c369d6',
	'f274df8d-b91d-489b-9239-c8e10d24ff27',
	'2d1703ff-6c0f-4e71-b92e-43fc23b88173',
	'4eccffbf-3f9f-4e70-b8c2-832fb76cda7e',
	'1c71f8f3-d94d-4cbe-b6d5-2a35607e2383',
]

export const AI_CHATBOT_ALLOWED_EMAILS: string[] = [
	'william.lam@hkland.com',
	'kakui.lau1@hkland.com',
	'yt.yeung@hkland.com',
	'blam@hkland.com',
	'ksyuen@hkland.com',
	'causon.lai@hkland.com',
	'khng@hkland.com',
	'raymond.ko@hkland.com',
	'phoebe.chiu@hkland.com',
	'mick.tse@hkland.com',
	'alexng@hkland.com',
	'kwchan@hkland.com',
	'auster.au@hkland.com',
	'carrie.chow@hkland.com',
	'cchan@hkland.com',
	'derek.wcchan@hkland.com',
	'don.tse@hkland.com',
	'ebarrow@hkland.com',
	'erik.loo@hkland.com',
	'fhung@hkland.com',
	'frankie.leung@hkland.com',
	'daniel.tsang@hkland.com',
	'charlotte.lai@hkland.com',
	'gary.ng@hkland.com',
	'idy.lam@hkland.com',
	'jacksonchian@hkland.com',
	'jacky.law@hkland.com',
	'joe.lam@hkland.com',
	'kane.huang@hkland.com',
	'kitty.yeung@hkland.com',
	'loretta.lee@hkland.com',
	'yf.man@hkland.com',
	'percywong@hkland.com',
	'sammi.cheng@hkland.com',
	'swong@hkland.com',
	'wkum@hkland.com',
	'ziv.ip@hkland.com',
	'kenneth.foo@hkland.com',
	'ryan.tang@hkland.com',
	'jessie.chu@hkland.com',
	'kevin.leung@hkland.com',
	'datacore@varadise.cloud',
	'ifmct.maint@hkland.com',
]

const normalizeEmail = (email?: string) => {
	return email?.trim().toLowerCase() || ''
}

export const hasAiChatbotLandingAccess = (roleIds: readonly string[] = [], email?: string) => {
	const normalizedEmail = normalizeEmail(email)

	return (
		roleIds.some((roleId) => AI_CHATBOT_ALLOWED_ROLE_IDS.includes(roleId)) ||
		(normalizedEmail ? AI_CHATBOT_ALLOWED_EMAILS.includes(normalizedEmail) : false)
	)
}
